
import { useContext } from "react";
import { Link } from "react-router-dom";
import UserContext from "../../contexts/UserContext";
import { textes } from "../../constants/textes";


export default function Abonnement({abonnement, position}) {
    // states
    const {user} = useContext(UserContext);


    // comportements


    // Affichage
    return (
        <tr style={{borderStyle: "none"}}>
            <td className="text-center">{position + 1}</td>
            <td>
                <div className="d-flex flex-row">
                    <div className="widget-content-left mr-3">
                        <img style={{width: 48, height: 48}} className="rounded" src={abonnement.img !== null ? abonnement?.img : "/assets/imgs/no-image.png"} alt="" />
                    </div>
                    <div className="widget-content-left">
                        <div className="widget-heading">{abonnement?.lib} ({abonnement?.libtabonnement})</div>
                        <div className="widget-subheading">{abonnement?.prof}</div>
                    </div>
                </div>
            </td>
            <td>{abonnement?.duree}</td>
            {/* <td>{abonnement?.duree?.number } {abonnement?.duree?.unite}</td> */}
            <td>{abonnement?.prix} XAF</td>
            <td>
                <span 
                    className={`badge ${
                        abonnement.etat === 1 ? "badge-success" : 
                        abonnement.etat === 2 ? "badge-danger" : 
                        ""
                        } mt-2`
                    } 
                    style={{fontSize: 14}}>
                        {abonnement?.etatdef}
                </span>
            </td>
            <td>{abonnement?.datecrea.slice(0, 16).replace("T", " à ")}</td>
            <td className="text-center">
                {(user?.isFullAction || user?.isAdminAction || user?.isConsulterAbonnement) && 
                    <Link to={`/abonnement/${abonnement?.code}`} data-toggle="tooltip" title={textes.fr.viewabonnementlabel} data-placement="left" className="btn-shadow-primary mr-2 ml-2 btn btn-sm btn-primary">
                        <i className="fa fa-eye"></i>
                    </Link>
                }
            </td>
        </tr>
    )
}